module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_026.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_026.png
// module id = 2342
// module chunks = 5